// @flow
import moment from 'moment';

import fetch from 'utils/fetch';
import { formatMinutesAsTime } from 'utils/datetime';

export const MAP_SET_VIEWPORT = 'map/SET_VIEWPORT';
export const MAP_SET_CENTER = 'map/SET_CENTER';
export const MAP_SET_FIT_BOUNDS = 'map/SET_FIT_BOUNDS';
export const MAP_SET_BACKGROUND = 'map/SET_BACKGROUND';
export const MAP_TOGGLE_EXTRUSION = 'map/TOGGLE_EXTRUSION';
export const MAP_TOGGLE_EXTRUSION_RAW = 'map/TOGGLE_EXTRUSION_RAW';
export const MAP_TOGGLE_STYLE_CATEGORY = 'map/TOGGLE_STYLE_CATEGORY';
export const MAP_TOGGLE_AIRPORTS = 'map/TOGGLE_AIRPORTS';
export const MAP_TOGGLE_AIRCRAFTS = 'map/TOGGLE_AIRCRAFTS';
export const MAP_SET_VISIBLE_AIRSPACES = 'map/SET_VISIBLE_AIRSPACES';
export const MAP_SET_SELECTED_FEATURE = 'map/SET_SELECTED_FEATURE';
export const MAP_RESET_VIEWPORT = 'map/RESET_VIEWPORT';

export function setViewport(viewport) {
  return {
    type: MAP_SET_VIEWPORT,
    viewport,
  };
}

export function resetViewport() {
  return {
    type: MAP_RESET_VIEWPORT,
  };
}

export function setCenter(center) {
  return {
    type: MAP_SET_CENTER,
    center,
  };
}

export function setFitBounds(fitBounds) {
  return {
    type: MAP_SET_FIT_BOUNDS,
    fitBounds,
  };
}

export function setBackground(background) {
  return {
    type: MAP_SET_BACKGROUND,
    background,
  };
}

export function toggleStyleCategory(styleCategory) {
  return {
    type: MAP_TOGGLE_STYLE_CATEGORY,
    styleCategory,
  };
}

export function toggleAirports(showAirports) {
  return {
    type: MAP_TOGGLE_AIRPORTS,
    showAirports,
  };
}

export function toggleAircrafts(showAircrafts) {
  return {
    type: MAP_TOGGLE_AIRCRAFTS,
    showAircrafts,
  };
}

export function toggleExtrusion(showExtrusion) {
  return {
    type: MAP_TOGGLE_EXTRUSION,
    showExtrusion,
  };
}

export function toggleExtrusionRaw(showExtrusion) {
  return {
    type: MAP_TOGGLE_EXTRUSION_RAW,
    showExtrusion,
  };
}

export function updateVisibleAirspaces() {
  return (dispatch, getState) => {
    const {
      filters: { dateRange, timeRange },
    } = getState();

    if (!dateRange.min || !dateRange.max) {
      return;
    }

    fetch(
      [
        '/api/v1/as/t',
        moment(dateRange.min)
          .startOf('day')
          .unix(),
        moment(dateRange.max)
          .endOf('day')
          .unix(),
        formatMinutesAsTime()(timeRange.min),
        formatMinutesAsTime()(timeRange.max),
      ].join('/')
    )
      .then(response => response.json())
      .then(visibleAirspaces => {
        dispatch({
          type: MAP_SET_VISIBLE_AIRSPACES,
          visibleAirspaces,
        });
      });
  };
}

export function setSelectedFeature(selectedFeature) {
  return dispatch => {
    dispatch({
      type: MAP_SET_SELECTED_FEATURE,
      selectedFeature,
    });
  };
}



// WEBPACK FOOTER //
// ./actions/map.js